(function () {
  function initWeddingSection(section) {
    if (!section || section.dataset.wbInitialized === 'true') return;

    section.dataset.wbInitialized = 'true';

    /* ==========================================
       SCROLL SUAVE
       ========================================== */

    const scrollLinks = section.querySelectorAll('[data-wb-scroll]');

    scrollLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        const selector = link.getAttribute('href');

        if (!selector || !selector.startsWith('#')) return;

        const target = document.querySelector(selector);

        if (!target) return;

        event.preventDefault();

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    });


    /* ==========================================
       ESTADO VISUAL CHECKBOXES
       ========================================== */

    const checkboxes = section.querySelectorAll(
      '.wb-check input[type="checkbox"]'
    );

    checkboxes.forEach(function (checkbox) {
      const wrapper = checkbox.closest('.wb-check');

      if (!wrapper) return;

      function updateState() {
        wrapper.classList.toggle(
          'is-selected',
          checkbox.checked
        );
      }

      updateState();

      checkbox.addEventListener('change', updateState);
    });


    /* ==========================================
       VALIDACIÓN BÁSICA DEL FORMULARIO
       ========================================== */

    const form = section.querySelector('#WeddingProjectForm');

    if (!form) return;

    form.addEventListener('submit', function (event) {
      const requiredFields = form.querySelectorAll('[required]');

      let firstInvalid = null;

      requiredFields.forEach(function (field) {
        if (!field.checkValidity() && !firstInvalid) {
          firstInvalid = field;
        }
      });

      if (firstInvalid) {
        event.preventDefault();

        firstInvalid.focus();

        firstInvalid.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    });
  }


  function initAllWeddingSections() {
    const sections = document.querySelectorAll(
      '[data-wedding-section]'
    );

    sections.forEach(initWeddingSection);
  }


  /* Primera carga */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllWeddingSections
    );
  } else {
    initAllWeddingSections();
  }


  /* Shopify Theme Editor */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      const section =
        event.target.querySelector('[data-wedding-section]') ||
        (
          event.target.matches &&
          event.target.matches('[data-wedding-section]')
            ? event.target
            : null
        );

      if (section) {
        initWeddingSection(section);
      }
    }
  );
})();